import { Link } from 'react-router-dom';
import { RedirectCategoryTypes } from '../../../enums';
import { rewriteImageUrl } from '../../../helpers';
import { Category } from '../../../models/Categories';

interface CategoryListItemProps {
  category: Category;
}

export default function CategoryListItem(
  props: Readonly<CategoryListItemProps>,
) {
  const { category } = props;
  const imgSrc = rewriteImageUrl(category.image2 || category.image || '');
  let url = '';
  if (category.redirectCategoryId) {
    category.redirectType === RedirectCategoryTypes.Flexible
      ? (url = `/flexible-benefits/${category.redirectCategoryId}`)
      : (url = `/club-benefits/${category.redirectCategoryId}`);
  } else {
    url = `${category.id}`;
  }

  return (
    <Link to={url} className="card category-card">
      <div className="card-img">
        <img src={imgSrc} alt={category.name} />
      </div>
      <div className="card-details">
        <div className="card-title">{category.name}</div>
      </div>
    </Link>
  );
}
